import Vue from 'vue';

Vue.filter('metadata', (value, field) => {

  if (!value || !value[field]) return {};

	if (field == 'threshold') {
		const string = value[field].value
		value[field].value = string.replace("tensor(", "").replace('[', "").replace('])', "");
		value[field].value = value[field].value * 100
		value[field].value = Math.floor(value[field].value)
	}

  return value[field].value;
});